<template>
   <div class="c-single-car-slider" v-if="loaded">
        <div>
            <div class="c-single-car-slider__item">
                <img :src="currentColor.image.url" alt="">
            </div>
           
        </div>
        <div class="c-single-car-color-selector">

            <div class="c-single-car-color-selector__exterior">
                <p class="c-single-car-color-selector__info">Couleur extérieure</p>
                <div v-for="(color, index) in currentTrim.colors" :key="index" :class="{'-is-active': code == color.code}" class="c-single-car-color-selector__item" :style="getColorStyle(color)" @click="code = color.code"></div>
                <p class="c-single-car-color-selector__selected">{{ colorName }}</p>
            </div>
            <div v-if="currentTrim.inside_colors && currentTrim.inside_colors.length" class="c-single-car-color-selector__interior">
                <p class="c-single-car-color-selector__info">Intérieur</p>
                <div v-for="(color, index) in currentTrim.inside_colors" :key="index" :class="{'-is-active': icode == color.code,'-is-last': index == currentTrim.inside_colors.length-1}" class="c-single-car-color-selector__item" :style="{backgroundColor: color.color}" @click="icode = color.code"></div>
                <p class="c-single-car-color-selector__selected">{{ icolorName }}</p>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TrimSelector',
    
    data() {
        return {
           currentTrim: {},
           loaded: false,
           code: '',
           icode: ''
        }
    },
    computed: {
        currentColor() {
            return this.currentTrim.colors.find(color => color.code == this.code);
        },
        colorName() {
            return this.currentColor ? this.currentColor.name : '';
        },
        icolorName() {
            return this.currentTrim.inside_colors.find(color => color.code == this.icode).name;
        } 
    },
    watch: {
        currentTrim() {
            this.loaded = false;
            if (!this.currentColor) {
                this.code = this.currentTrim.colors[0].code;
            }
            this.icode = this.currentTrim.inside_colors[0].code;
            this.loaded = true;

        },
        code() {
            document.$trigger('colorChanged', {color: this.code});
        }
    },
    methods: {
        bind() {
            document.$on('trimChanged', (data) => {
                this.currentTrim = data.detail.trim;
                this.loaded = true;
            });
        },
        getColorStyle(color) {
            if (!color.color_2) return {backgroundColor: color.color};
            return {
                background: `linear-gradient(262deg, ${color.color} 46%, ${color.color_2} 53%)`
            }
           
        }
    },
    mounted() {
        this.bind();
    },
    
}
</script>